module.exports = __webpack_public_path__ + "img/zl-gz.bff77860.svg";